module.exports = __webpack_public_path__ + "img/background-desktop-bottom.8c13d722.svg";